import {
  IAirtelMoneyError,
  IMvolaError,
  IOrangeMoneyError,
  IVisaError,
} from '../types/interface/paiement';

export const MAX_RETRIES = 3; // Maximum number of retry attempts
export const RETRY_DELAY = 1000; // Delay between retries in milliseconds (1 second)
export const SUCCESS_MESSAGE = 'Paiement effectué avec succès.';
export const ERROR_MESSAGE = 'Erreur sur le paiement';
export const LOADING_MESSAGE = `Traitement en cours, veuillez attendre jusqu'à la fin s'il vous plaît.`;
export const TRANSACTION_ERROR_MSG =
  'Une erreur pendant la transaction. Veuillez vérifier votre solde et votre code.';

export const showErrorValuesDefault = {
  numero: false,
  montant: false,
  motif: false,
};
export const showErrorValuesSubmit = {
  numero: true,
  montant: true,
  motif: true,
};

export const defaultAirtelMoneyErrorValues: IAirtelMoneyError = {
  numero: '',
  montant: '',
  motif: '',
  typeContrat: '',
  simulationId: '',
};

export const defaultOrangeMoneyErrorValues: IOrangeMoneyError = {
  montant: '',
  motif: '',
  typeContrat: '',
  simulationId: '',
};

export const showErrorTelmaValuesDefault = {
  montant: false,
  clientNumber: false,
  motif: false,
  typeContrat: false,
  nom: false,
};
export const showErrorTelmaValuesSubmit = {
  montant: true,
  clientNumber: true,
  motif: true,
  typeContrat: true,
  nom: true,
};

export const defaultTelmaErrorValues: IMvolaError = {
  montant: '',
  motif: '',
  clientNumber: '',
  typeContrat: '',
  nom: '',
  simulationId: '',
};

export const defaultVisaErrorValues: IVisaError = {
  montant: '',
  motif: '',
  typeContrat: '',
  simulationId: '',
};

export const redirectRoutesAfterPayment: Record<
  string,
  'DetailContratVoyage' | 'DetailContratRapatriement'
> = {
  'Assurance Voyage': 'DetailContratVoyage',
  'Assurance Obsèques à Dago': 'DetailContratRapatriement',
};
